var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2606_77772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.17228 24L6.04371 21.9699C5.99062 21.1039 6.23958 20.2463 6.74813 19.5434C7.25668 18.8405 7.99331 18.3358 8.83241 18.1153L11.9901 17.292C12.4309 17.1772 12.8411 16.9668 13.1914 16.6757C13.5417 16.3846 13.8237 16.0199 14.0173 15.6076C14.2108 15.1953 14.3112 14.7454 14.3114 14.2899C14.3115 13.8344 14.2114 13.3845 14.0181 12.972L7.92643 0H9.52028L15.3257 12.3489C15.6077 12.9535 15.7535 13.6126 15.753 14.2797C15.7525 14.9469 15.6056 15.6057 15.3227 16.2099C15.0398 16.8141 14.6278 17.3489 14.1158 17.7765C13.6037 18.2041 13.0041 18.5142 12.3591 18.6849L9.20099 19.506C8.68458 19.6426 8.23132 19.9536 7.91808 20.3862C7.60484 20.8189 7.45091 21.3466 7.48242 21.8799L7.61099 23.9987L6.17228 24Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5137 16.1807C9.94026 16.2193 9.3857 16.0226 8.8337 15.8974C8.23479 15.7505 7.62154 15.6699 7.00499 15.657C6.03047 15.6729 5.05902 15.7709 4.10098 15.9501C2.71113 16.1901 1.04827 15.8276 0.35184 14.481C-0.646303 12.561 0.780405 9.65956 0.944976 9.33813L2.22642 9.99342L1.57371 9.67199L2.21441 10.0007C1.85912 10.6993 1.05726 12.7461 1.61912 13.8266C2.22898 15.0026 3.90898 14.5294 4.91441 14.3546C6.2177 14.1141 7.52099 13.8887 8.83628 13.74C9.87299 13.62 12.1744 13.3054 12.0043 15.0407C11.9271 15.7993 11.181 16.1327 10.5137 16.1807Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2606_77772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.753,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNose);
export default __webpack_public_path__ + "static/media/nose.1944b141.svg";
export { ForwardRef as ReactComponent };